import axios from "axios";
import userData from "@/plugins/userData";
import Highcharts from "highcharts";
import drilldown from "highcharts/modules/drilldown";
import exporting from "highcharts/modules/exporting";
import exportingExcel from "highcharts/modules/export-data";
import accessibility from "highcharts/modules/accessibility";
import seriesLabel from "highcharts/modules/series-label";
import highContrastLight from "highcharts/themes/high-contrast-light";
import highContrastData from "highcharts/modules/data";
import moment from "moment";

// Inisialisasi modul Highcharts
drilldown(Highcharts);
exporting(Highcharts);
exportingExcel(Highcharts);
accessibility(Highcharts);
seriesLabel(Highcharts);
highContrastLight(Highcharts);
highContrastData(Highcharts);

export default {
  name: "DashboardPage",
  mixins: [userData],
  data() {
    return {
      filter: {
        year: "",
        month: "",
      },
      isLoadingA: false,
      isLoadingB: false,
      isLoadingC: false,
      isLoadingD: false,
      isLoadingE: false,
      isLoadingF: false,
      isLoadingG: false,
      isLoadingH: false,
      isLoadingI: false,
      isLoadingJ: false,
      total_customer: 0,
      total_transaction: 0,
      total_payment: 0,
      total_online_payment: 0,
      total_payment_day: 0,
      target_income: 0,
      realization_target: 0,
      transaction_by_district: [],
      transaction_by_village: [],
      transaction_by_category: [],
      transaction_by_users: [],
      transaction_by_months: [],
      transaction_by_date: [],
      biller_performance: [],
      satgas_performance: [],
      customer_comparison_district: [],
      customer_comparison_village: [],
      customer_district: [],
      customer_village: [],
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    percentage() {
      return (
        (this.total_online_payment / this.realization_target) *
        100
      ).toFixed(2);
    },
  },
  methods: {
    fetchData() {
      this.fetchA();
    },
    fetchA() {
      this.isLoadingA = true;
      axios
        .get("/v1/dashboard/", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            year: this.filter.year,
            month: this.filter.month,
          },
        })
        .then((response) => {
          this.total_customer = response.data.total_customer;
          this.total_transaction = response.data.total_transaction;
          this.total_payment = response.data.total_payment;
          this.total_online_payment = response.data.total_online_payment;
          this.total_payment_day = response.data.total_payment_day;
          this.target_income = response.data.target_income;
          this.realization_target = response.data.realization_target;
          this.isLoadingA = false;
          this.fetchB();
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
        });
    },
    fetchB() {
      this.isLoadingF = true;
      axios
        .get("/v1/dashboard/transaction-by-date", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            year: this.filter.year,
            month: this.filter.month,
          },
        })
        .then((response) => {
          this.transaction_by_date = response.data.transaction_by_date;
          this.isLoadingF = false;
          this.renderBarDaily();
          this.fetchC();
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
        });
    },
    fetchC() {
      this.isLoadingI = true;
      axios
        .get("/v1/dashboard/customer-comparison", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            year: this.filter.year,
            month: this.filter.month,
          },
        })
        .then((response) => {
          this.satgas_performance = response.data.satgas_performance;
          this.customer_comparison_district =
            response.data.customer_comparison_district;
          this.customer_comparison_village =
            response.data.customer_comparison_village;
          this.isLoadingI = false;
          this.renderCustomerComparison();
          this.fetchD();
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
        });
    },
    fetchD() {
      this.isLoadingD = true;
      axios
        .get("/v1/dashboard/transaction-by-users", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            year: this.filter.year,
            month: this.filter.month,
          },
        })
        .then((response) => {
          this.transaction_by_users = response.data.transaction_by_users;
          this.isLoadingD = false;
          this.renderBarUsers();
          this.fetchE();
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
        });
    },
    fetchE() {
      this.isLoadingE = true;
      axios
        .get("/v1/dashboard/transaction-by-months", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            year: this.filter.year,
            month: this.filter.month,
          },
        })
        .then((response) => {
          this.transaction_by_months = response.data.transaction_by_months;
          this.isLoadingE = false;
          this.renderBarMonths();
          this.fetchF();
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
        });
    },
    fetchF() {
      this.isLoadingB = true;
      axios
        .get("/v1/dashboard/transaction-by-district", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            year: this.filter.year,
            month: this.filter.month,
          },
        })
        .then((response) => {
          this.transaction_by_district = response.data.transaction_by_district;
          this.transaction_by_village = response.data.transaction_by_village;
          this.isLoadingB = false;
          this.renderDrilDownDisctrict();
          this.renderPieDistrict();
          this.fetchG();
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
        });
    },
    fetchG() {
      this.isLoadingC = true;
      axios
        .get("/v1/dashboard/transaction-by-category", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            year: this.filter.year,
            month: this.filter.month,
          },
        })
        .then((response) => {
          this.transaction_by_category = response.data.transaction_by_category;
          this.isLoadingC = false;
          this.renderBarCategory();
          this.fetchH();
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
        });
    },
    fetchH() {
      this.isLoadingH = true;
      axios
        .get("/v1/dashboard/satgas-performance", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            year: this.filter.year,
            month: this.filter.month,
          },
        })
        .then((response) => {
          this.satgas_performance = response.data.satgas_performance;
          this.isLoadingH = false;
          this.renderPerformanceSatgas();
          this.fetchI();
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
        });
    },
    fetchI() {
      this.isLoadingG = true;
      axios
        .get("/v1/dashboard/biller-performance", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            year: this.filter.year,
            month: this.filter.month,
          },
        })
        .then((response) => {
          this.biller_performance = response.data.biller_performance;
          this.isLoadingG = false;
          this.renderPerformance();
          this.fetchJ();
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
        });
    },
    fetchJ() {
      this.isLoadingJ = true;
      axios
        .get("/v1/dashboard/potential-customer", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            year: this.filter.year,
            month: this.filter.month,
          },
        })
        .then((response) => {
          this.customer_district = response.data.customer_district;
          this.customer_village = response.data.customer_village;
          this.isLoadingJ = false;
          // this.renderCustomers();
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
        });
    },
    renderCustomers() {
      var kecamatanData = this.customer_district;
      var kelurahanData = this.customer_village;

      var processedData = [];

      kecamatanData.forEach(function (kecamatan) {
        var idPrefix = kecamatan.id_kec + "-";

        // Process sudah bayar data
        processedData.push({
          id: idPrefix + "D",
          name: "Realisasi Pelanggan",
          data: kelurahanData
            .filter(function (kelurahan) {
              return kelurahan.id_kec === kecamatan.id_kec;
            })
            .map(function (kelurahan) {
              return [kelurahan.nama_kel, parseInt(kelurahan.pelanggan_baru)];
            }),
        });

        // Process belum bayar data
        processedData.push({
          id: idPrefix + "U",
          name: "Potensi",
          data: kelurahanData
            .filter(function (kelurahan) {
              return kelurahan.id_kec === kecamatan.id_kec;
            })
            .map(function (kelurahan) {
              return [kelurahan.nama_kel, parseInt(kelurahan.pelanggan_lama)];
            }),
        });
      });

      Highcharts.chart(this.$refs.barComparisonCustomers, {
        chart: {
          type: "column",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "Perbandingan Migrasi Data Pelanggan Berdasarkan Data Potensial",
        },
        subtitle: {
          text: "Klik Nama Kecamatan Untuk Melihat Detail/Kelurahan",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Jumlah",
          },
        },
        legend: {
          enabled: true,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [
          {
            name: "Potensi",
            data: this.customer_district.map((data) => ({
              name: data.nama_kec,
              y: parseInt(data.pelanggan_lama),
              drilldown: data.id_kec + "-U",
            })),
            color: "#265FB5",
          },
          {
            name: "Realisasi Pelanggan",
            data: this.customer_district.map((data) => ({
              name: data.nama_kec,
              y: parseInt(data.pelanggan_baru),
              drilldown: data.id_kec + "-D",
            })),
            color: "#698F01",
          },
        ],
        drilldown: { allowPointDrilldown: true, series: processedData },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
            },
            menuButtonTextKey: {
              viewFullscreen: "Tampilkan Layar Penuh",
            },
          },
        },
      });
    },
    renderCustomerComparison() {
      var kecamatanData = this.customer_comparison_district;
      var kelurahanData = this.customer_comparison_village;

      var processedData = [];

      kecamatanData.forEach(function (kecamatan) {
        var idPrefix = kecamatan.id_kec + "-";

        // Process customers data

        processedData.push({
          id: idPrefix + "C",
          name: "Pelanggan",
          data: kelurahanData
            .filter(function (kelurahan) {
              return kelurahan.id_kec === kecamatan.id_kec;
            })
            .map(function (kelurahan) {
              return [kelurahan.nama_kel, parseInt(kelurahan.pelanggan)];
            }),
        });
        // Process sudah bayar data
        processedData.push({
          id: idPrefix + "D",
          name: "Sudah Bayar",
          data: kelurahanData
            .filter(function (kelurahan) {
              return kelurahan.id_kec === kecamatan.id_kec;
            })
            .map(function (kelurahan) {
              return [kelurahan.nama_kel, parseInt(kelurahan.sudah_bayar)];
            }),
        });

        // Process belum bayar data
        processedData.push({
          id: idPrefix + "U",
          name: "Belum Bayar",
          data: kelurahanData
            .filter(function (kelurahan) {
              return kelurahan.id_kec === kecamatan.id_kec;
            })
            .map(function (kelurahan) {
              return [kelurahan.nama_kel, parseInt(kelurahan.belum_bayar)];
            }),
        });
      });

      Highcharts.chart(this.$refs.barComparison, {
        chart: {
          type: "column",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "Status Pembayaran Bulan Ini",
        },
        subtitle: {
          text: "Klik Nama Kecamatan Untuk Melihat Detail/Kelurahan",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Jumlah",
          },
        },
        legend: {
          enabled: true,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [
          {
            name: "Pelanggan",
            data: this.customer_comparison_district.map((data) => ({
              name: data.nama_kec,
              y: parseInt(data.pelanggan),
              drilldown: data.id_kec + "-C",
            })),
            color: "#FE8E00",
          },
          {
            name: "Belum Bayar",
            data: this.customer_comparison_district.map((data) => ({
              name: data.nama_kec,
              y: parseInt(data.belum_bayar),
              drilldown: data.id_kec + "-U",
            })),
            color: "#2D353C",
          },
          {
            name: "Sudah Bayar",
            data: this.customer_comparison_district.map((data) => ({
              name: data.nama_kec,
              y: parseInt(data.sudah_bayar),
              drilldown: data.id_kec + "-D",
            })),
            color: "#698F01",
          },
        ],
        drilldown: { allowPointDrilldown: true, series: processedData },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
            },
            menuButtonTextKey: {
              viewFullscreen: "Tampilkan Layar Penuh",
            },
          },
        },
      });
    },
    drillDownCustomerComparison(kecamatanData) {
      const kelurahanData = this.customer_comparison_village;
      const kecamatanId = kecamatanData.id_kec;

      const belumBayarData = kelurahanData
        .filter(
          (data) =>
            data.id_kec === kecamatanId &&
            data.status_pembayaran === "belum_bayar"
        )
        .map(
          (kelurahan) => (kelurahan.nama_kel, parseInt(kelurahan.belum_bayar))
        );

      const sudahBayarData = kelurahanData
        .filter(
          (data) =>
            data.id_kec === kecamatanId &&
            data.status_pembayaran === "sudah_bayar"
        )
        .map(
          (kelurahan) => (kelurahan.nama_kel, parseInt(kelurahan.sudah_bayar))
        );

      return [belumBayarData, sudahBayarData];
    },
    renderDrilDownDisctrict() {
      Highcharts.chart(this.$refs.drilldownDistrict, {
        chart: {
          type: "bar",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "Jumlah Transaksi Berdasarkan Kecamatan",
        },
        subtitle: {
          text: "Klik Nama Kecamatan Untuk Melihat Detail/Kelurahan",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Jumlah Penerimaan",
          },
          labels: {
            formatter: function () {
              return this.value !== 0 ? this.value / 1000000 + " Juta" : "0";
            },
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return "Rp. " + Highcharts.numberFormat(this.y, 0, ",", ".");
              },
            },
          },
        },
        tooltip: {
          formatter: function () {
            return (
              "<b>" +
              this.point.name +
              "</b><br>Rp. " +
              Highcharts.numberFormat(this.y, 0, ",", ".")
            );
          },
        },
        series: [
          {
            name: "Kecamatan",
            data: this.transaction_by_district.map((data) => ({
              name: data.nama,
              y: parseInt(data.jumlah),
              drilldown: data.id_kec,
            })),
            colorByPoint: true,
          },
        ],
        drilldown: {
          series: this.transaction_by_district.map((kecamatanData) => ({
            id: kecamatanData.id_kec,
            name: kecamatanData.nama,
            data: this.drillDownDisctrict(kecamatanData),
          })),
        },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
            },
            menuButtonTextKey: {
              viewFullscreen: "Tampilkan Layar Penuh",
            },
          },
        },
      });
    },
    drillDownDisctrict(kecamatanData) {
      const kelurahanData = this.transaction_by_village;
      const kecamatanId = kecamatanData.id_kec;

      return kelurahanData
        .filter((data) => data.id_kec === kecamatanId)
        .map((kelurahan) => ({
          name: kelurahan.nama,
          y: parseInt(kelurahan.jumlah),
        }));
    },
    renderPieDistrict() {
      Highcharts.chart(this.$refs.pieDistrict, {
        chart: {
          type: "pie",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "Persentase Transaksi Berdasarkan Kecamatan",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.percentage:.1f} %",
              distance: 5,
            },
          },
        },
        tooltip: {
          formatter: function () {
            return (
              "<b>" +
              this.point.name +
              "</b><br>Rp. " +
              Highcharts.numberFormat(this.y, 0, ",", ".")
            );
          },
        },
        series: [
          {
            name: "Kecamatan",
            colorByPoint: true,
            data: this.transaction_by_district.map((data) => ({
              name: data.nama,
              y: parseInt(data.jumlah),
              drilldown: data.id_kec,
            })),
          },
        ],
        drilldown: {
          series: this.transaction_by_district.map((kecamatanData) => ({
            id: kecamatanData.id_kec,
            name: kecamatanData.nama,
            data: this.drillDownDisctrict(kecamatanData),
          })),
        },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
            },
            menuButtonTextKey: {
              viewFullscreen: "Tampilkan Layar Penuh",
            },
          },
        },
      });
    },
    renderBarCategory() {
      Highcharts.chart(this.$refs.barCategory, {
        chart: {
          type: "bar",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "Jumlah Transaksi Berdasarkan Jenis Kegiatan",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Jumlah Penerimaan",
          },
          labels: {
            formatter: function () {
              return this.value !== 0 ? this.value / 1000000 + " Juta" : "0";
            },
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return "Rp. " + Highcharts.numberFormat(this.y, 0, ",", ".");
              },
            },
          },
        },
        tooltip: {
          formatter: function () {
            return (
              "<b>" +
              this.point.name +
              "</b><br>Rp. " +
              Highcharts.numberFormat(this.y, 0, ",", ".")
            );
          },
        },
        series: [
          {
            name: "Kecamatan",
            data: this.transaction_by_category.map((data) => ({
              name: data.category,
              y: parseInt(data.jumlah),
            })),
            colorByPoint: true,
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
            },
            menuButtonTextKey: {
              viewFullscreen: "Tampilkan Layar Penuh",
            },
          },
        },
      });
    },
    renderBarUsers() {
      const jsonData = this.transaction_by_users;
      const userNames = jsonData.map((item) => item.nama_pengguna);
      const totalAmounts = jsonData.map((item) => parseInt(item.jumlah));
      const skrd = jsonData.map((item) => parseInt(item.skrd));
      const ssrd = jsonData.map((item) => parseInt(item.ssrd));

      Highcharts.chart(this.$refs.barUsers, {
        chart: {
          type: "column",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "Jumlah Transaksi dan Penerimaan Hari Ini",
        },
        xAxis: {
          categories: userNames,
          crosshair: true,
          accessibility: {
            description: "Users",
          },
          labels: {
            formatter: function () {
              // Format nama sesuai kebutuhan Anda di sini
              // Misalnya, mengonversi setiap kata menjadi huruf besar
              return this.value
                .split(" ")
                .map(function (word) {
                  return word.charAt(0).toUpperCase() + word.slice(1);
                })
                .join(" ");
            },
          },
        },
        yAxis: [
          {
            title: {
              text: "Jumlah Penerimaan",
            },
            labels: {
              formatter: function () {
                return this.value !== 0 ? this.value / 1000000 + " Juta" : "0";
              },
            },
          },
          {
            title: {
              text: "Jumlah Transaksi",
            },
            opposite: true,
          },
        ],
        tooltip: {
          shared: true,
          formatter: function () {
            return (
              "<b style='text-transform: capitalize'> " +
              this.x +
              "</b>" +
              "</b><br/>Jumlah Penerimaan : <b>Rp. " +
              Highcharts.numberFormat(this.points[2].y, 0, ",", ".") +
              "</b>" +
              "<br/>SKRD Dikeluarkan : <b>" +
              this.points[0].y +
              "</b><br/>SSRD Dikeluarkan : <b>" +
              this.points[1].y
            );
          },
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              rotation: -90,
              color: "#FFFFFF",
              align: "right",
              y: 10,
              formatter: function () {
                return Highcharts.numberFormat(this.y, 0, ",", ".");
              },
            },
          },
        },
        series: [
          {
            name: "SKRD",
            data: skrd,
            yAxis: 1,
            color: "#49B6D6",
          },
          {
            name: "SSRD",
            data: ssrd,
            yAxis: 1,
            color: "#265FB5",
          },
          {
            name: "Nilai Transaksi",
            data: totalAmounts,
            color: "#698F01",
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
            },
            menuButtonTextKey: {
              viewFullscreen: "Tampilkan Layar Penuh",
            },
          },
        },
      });
    },
    renderBarMonths() {
      Highcharts.chart(this.$refs.barMonths, {
        chart: {
          type: "column",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "Jumlah Realisasi Per Bulan Bayar",
        },
        subtitle: {
          text:
            "Target Per Bulan : Rp. " + this.numberFormat(this.target_income),
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Jumlah Penerimaan",
          },
          labels: {
            formatter: function () {
              return this.value !== 0 ? this.value / 1000000 + " Juta" : "0";
            },
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return "Rp. " + Highcharts.numberFormat(this.y, 0, ",", ".");
              },
            },
          },
        },
        tooltip: {
          formatter: function () {
            return (
              "<b>" +
              this.point.name +
              "</b><br>Rp. " +
              Highcharts.numberFormat(this.y, 0, ",", ".")
            );
          },
        },
        series: [
          {
            name: "Kecamatan",
            data: this.transaction_by_months.map((data) => ({
              name: data.nama_bulan,
              y: parseInt(data.jumlah_transaksi),
            })),
            colorByPoint: true,
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
            },
            menuButtonTextKey: {
              viewFullscreen: "Tampilkan Layar Penuh",
            },
          },
        },
      });
    },
    renderBarDaily() {
      Highcharts.chart(this.$refs.barDaily, {
        chart: {
          type: "spline",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "Tren Transaksi Harian",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Jumlah Penerimaan",
          },
          labels: {
            formatter: function () {
              return this.value !== 0 ? this.value / 1000000 + " Juta" : "0";
            },
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return "Rp. " + Highcharts.numberFormat(this.y, 0, ",", ".");
              },
            },
          },
        },
        tooltip: {
          formatter: function () {
            return (
              "<b>" +
              this.point.name +
              "</b><br>Rp. " +
              Highcharts.numberFormat(this.y, 0, ",", ".")
            );
          },
        },
        series: [
          {
            name: "Jumlah Transaksi",
            data: this.transaction_by_date.map((data) => ({
              name: this.dateShortFormat(data.transaction_date),
              y: parseInt(data.jumlah_transaksi),
            })),
            colorByPoint: true,
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
            },
            menuButtonTextKey: {
              viewFullscreen: "Tampilkan Layar Penuh",
            },
          },
        },
      });
    },
    numberFormat(value) {
      if (!value) return "0";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    currencyFormat(value) {
      if (!value) return "0";
      return "Rp. " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    dateShortFormat(dateTime) {
      return moment(dateTime).format("DD-MM-YY");
    },
    capitalizeEachWord(str) {
      return str.replace(/\b\w/g, function (char) {
        return char.toLowerCase();
      });
    },
    renderPerformance() {
      const jsonData = this.biller_performance;
      const userNames = jsonData.map((item) => item.full_name);
      const costumers = jsonData.map((item) => parseInt(item.costumers));
      const transactions = jsonData.map((item) => parseInt(item.transactions));

      Highcharts.chart(this.$refs.barPerformance, {
        chart: {
          type: "column",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "Performa Verifikator Kecamatan",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          categories: userNames,
          crosshair: true,
          accessibility: {
            description: "Users",
          },
          labels: {
            formatter: function () {
              return this.value
                .split(" ")
                .map(function (word) {
                  return word.charAt(0).toUpperCase() + word.slice(1);
                })
                .join(" ");
            },
          },
        },
        yAxis: [
          {
            title: {
              text: "Jumlah Penerimaan",
            },
            labels: {
              formatter: function () {
                return this.value !== 0 ? this.value / 1000000 + " Juta" : "0";
              },
            },
          },
          {
            title: {
              text: "Jumlah",
            },
            opposite: true,
          },
        ],

        legend: {
          enabled: true,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return Highcharts.numberFormat(this.y, 0, ",", ".");
              },
            },
          },
        },
        tooltip: {
          shared: true,
          formatter: function () {
            return (
              "<b style='text-transform: capitalize'> " +
              this.x +
              "</b>" +
              "<br/>Pelanggan Terdata : <b>" +
              this.points[0].y +
              "</b><br/>Tagihan : <b>" +
              this.points[1].y
            );
          },
        },

        series: [
          {
            name: "Pelanggan Terdata",
            data: costumers,
            yAxis: 1,
            color: "#49B6D6",
          },
          {
            name: "Tagihan",
            data: transactions,
            yAxis: 1,
            color: "#265FB5",
          },
          // {
          //   name: "Laporan Sampah",
          //   data: reports,
          //   yAxis: 1,
          //   color: "#4C0684",
          // },
          // {
          //   name: "Laporan Ditangani",
          //   data: report_complete,
          //   yAxis: 1,
          //   color: "#698F01",
          // },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
            },
            menuButtonTextKey: {
              viewFullscreen: "Tampilkan Layar Penuh",
            },
          },
        },
      });
    },
    renderPerformanceSatgas() {
      const jsonData = this.satgas_performance;
      const userNames = jsonData.map((item) => item.full_name);
      const costumers = jsonData.map((item) => parseInt(item.costumers));
      const reports = jsonData.map((item) => parseInt(item.reports));
      const report_complete = jsonData.map((item) =>
        parseInt(item.report_complete)
      );
      Highcharts.chart(this.$refs.barPerformanceSatgas, {
        chart: {
          type: "bar",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: "Performa Satgas Kelurahan",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          categories: userNames,
          crosshair: true,
          accessibility: {
            description: "Users",
          },
          labels: {
            formatter: function () {
              return this.value
                .split(" ")
                .map(function (word) {
                  return word.charAt(0).toUpperCase() + word.slice(1);
                })
                .join(" ");
            },
          },
        },
        yAxis: [
          {
            title: {
              text: "Jumlah",
            },
            labels: {
              formatter: function () {
                return this.value !== 0 ? this.value / 1000000 + " Juta" : "0";
              },
            },
          },
          {
            title: {
              text: "Jumlah",
            },
            opposite: true,
          },
        ],

        legend: {
          enabled: true,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return Highcharts.numberFormat(this.y, 0, ",", ".");
              },
            },
          },
        },
        tooltip: {
          shared: true,
          formatter: function () {
            return (
              "<b style='text-transform: capitalize'> " +
              this.x +
              "</b>" +
              "<br/>Pelanggan Terdata : <b>" +
              this.points[0].y +
              "</b><br/>Laporan Sampah : <b>" +
              this.points[1].y +
              "</b><br/>Laporan Ditangai : <b>" +
              this.points[2].y
            );
          },
        },

        series: [
          {
            name: "Pelanggan Terdata",
            data: costumers,
            yAxis: 1,
            color: "#49B6D6",
          },
          {
            name: "Laporan Sampah",
            data: reports,
            yAxis: 1,
            color: "#B7104A",
          },
          {
            name: "Laporan Ditangani",
            data: report_complete,
            yAxis: 1,
            color: "#698F01",
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
            },
            menuButtonTextKey: {
              viewFullscreen: "Tampilkan Layar Penuh",
            },
          },
        },
      });
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
      }).format(value);
    },
  },
};
